module.exports = __webpack_public_path__ + "static/media/vsss.166c0c50.jpg";